import { Controller } from "@hotwired/stimulus"

const DELAY_MS = 300

export default class extends Controller<HTMLFormElement> {
  private timer?: number

  connect(): void {
    this.element.addEventListener("formdata", this.dropBlanks)
  }

  disconnect(): void {
    window.clearTimeout(this.timer)
    this.element.removeEventListener("formdata", this.dropBlanks)
  }

  queue(): void {
    window.clearTimeout(this.timer)
    this.timer = window.setTimeout(() => this.submit(), DELAY_MS)
  }

  submit(): void {
    window.clearTimeout(this.timer)
    this.element.requestSubmit()
  }

  private dropBlanks = (event: FormDataEvent): void => {
    const blanks = [...event.formData.entries()].filter(([, value]) => value === "").map(([name]) => name)
    blanks.forEach((name) => event.formData.delete(name))
  }
}
